import { hideScrollBar } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const CommentsWrapper = styled.div`
  & > p {
    color: ${themeStyle.varInkLight};
    text-decoration: underline;
    margin-bottom: 13px;
  }
`;

export const CommentsContainer = styled.div`
  flex: 1;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${hideScrollBar}
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
  text-align: center;
`;

export const TryAgain = styled.span`
  color: ${themeStyle.varInkMain};
  text-decoration: underline;
  cursor: pointer;
`;

export const SeeAllButton = styled.button`
  all: unset;
  color: ${themeStyle.varInkLight};
  line-height: 1.6;
  font-size: ${themeStyle.fontSize12};
  font-weight: ${themeStyle.fontMedium};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  text-decoration: ${({ disabled }) => (disabled ? 'none' : 'underline')};
`;

export const CommentsTotal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;
`;

export const ReplyWrapper = styled.div`
  position: relative;

  &.with-replies:after {
    content: '';
    position: absolute;
    top: 5px;
    left: 13px;
    width: 1px;
    height: calc(100% - 45px);
    background: ${themeStyle.varInkLight};
  }
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EmptyState = styled.div`
  width: 100%;
  padding: 10px 0;
  display: flex;
  align-items: center;
  margin-top: 10px;
  border-top: 1px solid ${themeStyle.varInkLight};
  border-bottom: 1px solid ${themeStyle.varInkLight};
  font-size: ${themeStyle.fontSize12};
  color: ${themeStyle.varInkMedium};
`;
